import api from "./services/mkm.api.js"

const resource = "/powerapp/fortbildung"

export default{
    alle(kuerzel) {
        return api.get(`${resource}/list/${kuerzel}`);
    },
    meta(){
        return {
            instrumente: function () {
                return api.get(`${resource}/instrumente`)
            },
            musikschulen: function(){
                return api.get(`${resource}/musikschulen`)
            },
            kreativakademien: function(){
                return api.get(`${resource}/kreativakademien`)
            }
        }
    },
    textbloecke(kuerzel) {
        return api.get(`${resource}/${kuerzel}/textbloecke`)
    }
}